import {
  NpssScheduledPost,
  NpssUserScheduledPostsQuery,
} from '@amzn/ring-neighbors-api-orchestrator-gql-schema';
import NPSS_USER_SCHEDULED_POSTS from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/npss/npssUserScheduledPosts.graphql';
import { useQuery } from '@apollo/client';
import { useIsNpssUser } from 'src/auth';

export const useGetNpssScheduledPosts = () => {
  const isNpssUser = useIsNpssUser();
  const { data, ...rest } = useQuery<NpssUserScheduledPostsQuery>(
    NPSS_USER_SCHEDULED_POSTS,
    {
      skip: !isNpssUser,
    },
  );

  return {
    ...rest,
    data: (data?.npssUserScheduledPosts ??
      []) as unknown as NpssScheduledPost[],
  };
};
